import { useCallback, useEffect, useState } from 'react';
import type { Subscription } from '../models/Subscription';
import { subscriptionService } from '../services/dataverse/subscriptionService';

export const useSubscriptions = (clientId?: string) => {
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadSubscriptions = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await subscriptionService.list(clientId);
      setSubscriptions(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unable to load subscriptions.');
    } finally {
      setLoading(false);
    }
  }, [clientId]);

  useEffect(() => { void loadSubscriptions(); }, [loadSubscriptions]);

  return { subscriptions, loading, error, reload: loadSubscriptions };
};
